var map = {
	"./template.bet575": 1665,
	"./template.bet575.tsx": 1665,
	"./template.bet777": 1666,
	"./template.bet777.tsx": 1666,
	"./template.betbetbet": 1667,
	"./template.betbetbet.tsx": 1667,
	"./template.betblast": 1668,
	"./template.betblast.tsx": 1668,
	"./template.betstride": 1669,
	"./template.betstride.tsx": 1669,
	"./template.buffalobet": 1670,
	"./template.buffalobet.tsx": 1670,
	"./template.default": 85,
	"./template.default.tsx": 85,
	"./template.fiestabet": 1671,
	"./template.fiestabet.tsx": 1671,
	"./template.forsport": 1672,
	"./template.forsport.tsx": 1672,
	"./template.gigabet": 1673,
	"./template.gigabet.tsx": 1673,
	"./template.goldenbet888": 1674,
	"./template.goldenbet888.tsx": 1674,
	"./template.goldenrush": 1675,
	"./template.goldenrush.tsx": 1675,
	"./template.hyperbet": 1676,
	"./template.hyperbet.tsx": 1676,
	"./template.juicybet": 1677,
	"./template.juicybet.tsx": 1677,
	"./template.magnumbet": 1678,
	"./template.magnumbet.tsx": 1678,
	"./template.oldgill": 1679,
	"./template.oldgill.tsx": 1679,
	"./template.puntcity": 1680,
	"./template.puntcity.tsx": 1680,
	"./template.pyramidbet": 1681,
	"./template.pyramidbet.tsx": 1681,
	"./template.slambet": 1682,
	"./template.slambet.tsx": 1682,
	"./template.sterlingparker": 1683,
	"./template.sterlingparker.tsx": 1683,
	"./template.sugarcastle": 1684,
	"./template.sugarcastle.tsx": 1684,
	"./template.templebet": 1685,
	"./template.templebet.tsx": 1685,
	"./template.titanbet": 1686,
	"./template.titanbet.tsx": 1686,
	"./template.ts": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2464;